// extracted by mini-css-extract-plugin
export var cardWrapper = "_50-0";